import React from 'react';
import UserCard from '../Components/User/UserCard';

const Users = () => (
  <UserCard />
);

export default Users;
